import React from 'react'
import { LoungeSettingsScreen } from '@/screens/lounges/LoungeSettingsScreen'

export default function LoungeSettingsRoute() {
  return <LoungeSettingsScreen />
}
